import React from 'react';

import ContentCard from 'pages/Landings/components/ContentCard';
import EmailLink from 'pages/Landings/components/EmailLink';

import ActionButton from '../ActionButton';

interface Props {
    className?: string;
}

const Support: React.FC<Props> = ({ className }) => {
    return (
        <ContentCard
            title={'Contact support'}
            subtitle={
                'Reach out to the technical team if you have any difficulties with API or our website features at'
            }
            additional={<EmailLink email="support@vulners.com" />}
            actions={
                <ActionButton color="light" href={'mailto:support@vulners.com'} fullWidth>
                    {'Contact support'}
                </ActionButton>
            }
            className={className}
        />
    );
};

export default Support;
